import { LeanFormSchema, fieldRef } from '../types/config-form.types';
import { V3HeatingFilmSettings } from 'ngx-modbus';

export const HEATING_FILM_FORM: LeanFormSchema = {
  version: '1',
  id: 'heating-film',
  name: 'Heating Film',
  sections: [{
    id: 'heating-film',
    labelKey: 'heatingFilmEnable',
    registerTable: 'V3HeatingFilmSettings',
    validityMask: 'AddressMask_Config_Basic1',
    fields: [
      fieldRef(V3HeatingFilmSettings, 'Heating_Film_Enable'),
    ],
  }],
};
